import React from "react";
import HomeDashboardLayout from "../homeDashboard/HomeDashboardLayout";
import "../dashboard/Dashboard.css";
import "./HomeDashboard.css";
import "./DashboardSkeleton.css";
import QuickAction from "./QuickAction";
import MyWalletSidebar from "./MyWalletSidebar";
import GamesSection from "./GamesSection";
import PreviousYearSection from "./PreviousYearSection";
import MyProgress from "./MyProgress";
import QuizzesSection from "./QuizzesSection";
import ChooseState from "./ChooseState";
import FavoriteExam from "./FavoriteExam";
import { useDashboardStatsData } from "../hooks/useDashboardStatsData";
import { useDashboardHeaderData } from "../hooks/useDashboardHeaderData";
import { useDashboardContentData } from "../hooks/useDashboardContentData";
import { useStates } from "../hooks/useStates";
import { useExamCategories } from "../hooks/useExamCategories";

const DASHBOARD_REFRESH_OPTIONS = { refetchOnMount: "always" };

//Import SVg

const HomeDashboard = () => {
  const {
    data: dashboardHeaderData,
    isLoading: headerLoading,
    isFetching: headerFetching,
    isPlaceholderData: headerPlaceholderData,
    isError: hasHeaderError,
    error: headerQueryError,
  } = useDashboardHeaderData(DASHBOARD_REFRESH_OPTIONS);
  const {
    data: dashboardStats = [],
    isLoading: statsLoading,
    isFetching: statsFetching,
    isPlaceholderData: statsPlaceholderData,
    isError: hasStatsError,
    error: statsQueryError,
  } = useDashboardStatsData(DASHBOARD_REFRESH_OPTIONS);
  const {
    data: dashboardContentData,
    isLoading: contentLoading,
    isFetching: contentFetching,
    isError: hasContentError,
    error: contentQueryError,
  } = useDashboardContentData(DASHBOARD_REFRESH_OPTIONS);
  const {
    data: statesData,
    isLoading: statesLoading,
    isFetching: statesFetching,
    isPlaceholderData: statesPlaceholderData,
    isError: hasStatesError,
    error: statesQueryError,
  } = useStates(DASHBOARD_REFRESH_OPTIONS);
  const {
    data: examCategoriesData,
    isLoading: examCategoriesLoading,
    isFetching: examCategoriesFetching,
    isPlaceholderData: examCategoriesPlaceholderData,
    isError: hasExamCategoriesError,
    error: examCategoriesQueryError,
  } = useExamCategories(DASHBOARD_REFRESH_OPTIONS);

  const isHeaderPending = headerLoading || (headerPlaceholderData && headerFetching);
  const isQuickActionsPending = isHeaderPending && !dashboardHeaderData?.looking_for_categories?.length;
  const isGamesPending = isHeaderPending && !dashboardHeaderData?.rapid_fire_battles?.length;
  const isStatsPending = (statsLoading || (statsPlaceholderData && statsFetching)) && dashboardStats.length === 0;
  const isContentPending = contentLoading || contentFetching;
  const isStatesPending = (statesLoading || (statesPlaceholderData && statesFetching)) && !statesData?.states?.length;
  const isExamCategoriesPending = (examCategoriesLoading || (examCategoriesPlaceholderData && examCategoriesFetching)) && !examCategoriesData?.exams?.length;

  const statsError = hasStatsError
    ? statsQueryError?.response?.data?.message || statsQueryError?.message || "Unable to load dashboard stats."
    : "";
  const headerError = hasHeaderError
    ? headerQueryError?.response?.data?.message || headerQueryError?.message || "Unable to load dashboard header data."
    : "";
  const contentError = hasContentError
    ? contentQueryError?.response?.data?.message || contentQueryError?.message || "Unable to load dashboard content data."
    : "";
  const statesError = hasStatesError
    ? statesQueryError?.response?.data?.message || statesQueryError?.message || "Unable to load states."
    : "";
  const examCategoriesError = hasExamCategoriesError
    ? examCategoriesQueryError?.response?.data?.message || examCategoriesQueryError?.message || "Unable to load exams."
    : "";

  return (
       <>
      <style>{`
        body{
        background:#fff!important;
        }
        @media (max-width: 767px) {
          .headerDash {
            display: none;
          }

          .layout-wrapper .main-content {
            padding-top: 0px !important;
          }
        }
      `}</style>
     <HomeDashboardLayout dashboardHeaderData={dashboardHeaderData}>


     <div className="innerContent ssssss">
      
      {/* My Progress Section */}
        <MyProgress
          stats={dashboardStats}
          isLoading={isStatsPending}
          error={statsError}
        />
       

      {/* Choose State Section */}
      <div className="grid-cards dashboard-collection-rows m-20">
        
          {/* Choose State Section */}
            <ChooseState
              states={statesData?.states}
              isLoading={isStatesPending}
              error={statesError}
            />
          {/* Favorite Exam Section */}
            <FavoriteExam
              exams={examCategoriesData?.exams}
              isLoading={isExamCategoriesPending}
              error={examCategoriesError}
            />

      </div>


      {/* Quick Action Section */}
      <div className="m-20">
        <QuickAction
          categories={dashboardHeaderData?.looking_for_categories}
          isLoading={isQuickActionsPending}
          error={headerError}
        />
      </div>

      {/* Games Section */}
      <div className="m-20">
          <GamesSection
            battles={dashboardHeaderData?.rapid_fire_battles}
            isLoading={isGamesPending}
            error={headerError}
          />

      </div>

     
      {/* Previous Year Section */}
      <div className="dashboard-cards m-20">
        
         <PreviousYearSection
           papers={dashboardContentData?.pyp?.current}
           isLoading={isContentPending}
           error={contentError}
         />
        
      </div>

      {/* Quizzes Section */}
      <div className="grid-cards m-20">
       
        <QuizzesSection
          title="Quizzes"
          sectionData={dashboardContentData?.quiz}
          isLoading={isContentPending}
          error={contentError}
        />
        <QuizzesSection
          title="Test Series"
          sectionData={dashboardContentData?.test_series}
          isLoading={isContentPending}
          error={contentError}
        />

      </div>
      {/* End Quizzes Section */}

    </div>
      
      {/* Fixed right sidebar */}
      <MyWalletSidebar showDailyQuestionCard />

    </HomeDashboardLayout>
    </>
  );
};
export default HomeDashboard;

